
export default class RSVPConfigQuestionAns {
    constructor(questionId, answerId, sortOrder, activeFlag, text) {
        this.questionId = questionId;
        this.answerId = answerId;
        this.sortOrder = sortOrder;
        this.activeFlag = activeFlag;
        this.text = text;
    }
  }